import { Bacs } from './bacs';

export class BacSearch {
  bac: Partial<Bacs>;
  totalCourriers: string;
  constructor(data?) {
    Object.assign(this, data);
    this.bac = new Bacs(this.bac);
  }
}
